
<script>
    import { Link } from 'svelte-routing';
    function showFyreHost()
    {
        //document.getElementById('fyrehost').hidden=false;
    }
    function hideFyreHost()
    {
        //document.getElementById('fyrehost').hidden=true;
    }
</script>
<div style="background-color: #101032; user-select: none;" class="w-0 h-0">
    <div class="absolute left-12 top-5 rounded-lg bg-blue-500">
        <Link to="/">
            <button on:click="{hideFyreHost}" class="h-12 w-12 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto" fill="none" viewBox="0 0 24 24" stroke="white">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
            </button>
        </Link>
        
    </div>

    <div class="absolute left-28 top-5 bg-blue-500 rounded-lg">
        <Link to="minecraft">
            <button on:click="{showFyreHost}"  style="background-image: url('https://static.wikia.nocookie.net/minecraft_gamepedia/images/2/2d/Plains_Grass_Block.png'); background-size: 35px 35px; background-repeat: no-repeat; background-position: center;" class="w-12 h-12 py-1 px-4 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">
            </button>
        </Link>
    </div>

    <div class="absolute left-44 top-5 bg-blue-500 rounded-lg">
        <Link to="factorio">
            <button on:click="{showFyreHost}" style="background-image: url('https://factorio.com/static/img/factorio-wheel.png'); background-size: 35px 35px; background-repeat: no-repeat; background-position: center;" class="w-12 h-12 py-1 px-4 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">
            </button>
        </Link>
    </div>

    <div class="absolute left-60 top-5 bg-blue-500 rounded-lg">
        <Link to="valheim">
            <button on:click="{showFyreHost}" style=" background-image: url('https://img.guildedcdn.com/asset/GameIcons/Valheim-lg.png'); background-size: 35px 35px; background-repeat: no-repeat; background-position: center;" class="w-12 h-12 py-1 px-4 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">
            </button>
        </Link>
    </div>

    <div class="absolute top-5 bg-blue-500 rounded-lg" style="left: 19rem;">
        <Link to="discord">
            <button on:click="{showFyreHost}" style=" background-image: url('https://i.imgur.com/cjw5DRw.png'); background-size: 35px 35px; background-repeat: no-repeat; background-position: center;" class="w-12 h-12 py-1 px-4 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">
            </button>
        </Link>
    </div>
   
    

    <div class="absolute right-80 top-5">
        <button style="z-index: 1;" onclick="window.open('mailto:support@fyrehost.net')" class="py-2 px-4 bg-blue-500 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">Support</button>
    </div>

    <div class="absolute right-56 top-5">
        <button style="z-index: 1;" onclick="window.open('https://docs.fyrehost.net')" class="py-2 px-4 bg-blue-500 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">Docs</button>
    </div>

    <div class="absolute right-32 top-5">
        <button style="z-index: 1;" onclick="window.open('https://panel.fyrehost.net')" class="py-2 px-4 bg-blue-500 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg">Panel</button>
    </div>
    <div class="h-32 w-full">

    </div>
    
</div>